import { render } from "./ModalBranchSelect.vue?vue&type=template&id=d0467b10"
import script from "./ModalBranchSelect.vue?vue&type=script&lang=js"
export * from "./ModalBranchSelect.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__